module.exports = __webpack_public_path__ + "img/unchecked-checkbox.b84057ac.svg";